export default ({ className = '', square = true, checked = false, text = '', required = false, disabled = false, onChange = () => {}, error = '', color }) => {

    return (
       <div className={`checkbox__outer ${color !== null ? `checkbox--${color}` : ''}`}>
            <div className="checkbox__inner">
                <div className={`checkbox-round ${square ? 'checkbox-square' : ''} ${disabled ? 'checkbox--disabled' : ''}`} onClick={() => onChange({ option: text, value: !checked })}>
                    <input type="checkbox" checked={checked} disabled={disabled} onChange={() => {}} />
                    <label for="checkbox" className={className}></label>
                </div>
                { typeof text === 'string' ?  <p dangerouslySetInnerHTML={{  __html: text }}></p> : <p>{ text }</p> }
                { required && <p style={{  fontSize: '11px', color: 'rgb(112, 112, 112)' }}>[Required]</p> }
            </div>
            { error && <p className="checkbox__error">{ error }</p> }
       </div>
    )
}
